import React, { useEffect, useRef, useState } from 'react';
import OftadehLayout from '../../components/OftadehLayout/OftadehLayout';
import { Button, CircularProgress } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { getDoctorList, getDoctorManagerList, getHospitalList, getLanguageList } from '../../constants/PromiseHttp';
import { API_URL, getDefName } from '../../constants';
import swal from '@sweetalert/with-react';
import axiosInstance from '../../constants/AxiosInstance';
import moment from 'moment';

import SearchIcon from '@material-ui/icons/Search';
import CustomListHeader from '../../components/Custom/CustomListHeader';
import { exportExcel } from '../../components/ExportData/ExcelExport';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';

const RecDoctorListPage = (props) => {
  const { history } = props;

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState();
  const [hospitals, setHospitals] = useState([]);
  const [languages, setLanguages] = useState([]);

  const tableStateRef = useRef([]);

  const getData = () => {
    setLoading(true);
    if (sessionStorage.getItem('bt_role') === 'SYS_MGR') {
      getDoctorManagerList(sessionStorage.getItem('bt_user')).then((result) => {
        setLoading(false);
        setData(result);
      });
    } else {
      getDoctorList().then((result) => {
        setLoading(false);
        setData(result);
      });
    }
  };

  const rowClick = (rowData) => {
    history.push(`/pages/recDoctor/detail?type=edit&id=${rowData.id}`);
  };

  const handleFilteredExcelDownload = () => {
    const displayData = tableStateRef.current || [];
    const filteredData = displayData.map(({ dataIndex }) => data[dataIndex]);
    exportExcel({ jsonData: filteredData, type: 'Doctor', languages, hospitals });
  };

  const cols = [
    {
      name: 'id',
      label: 'id',
      options: {
        filter: false,
        sort: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: 'id',
      label: 'No.',
      options: {
        filter: false,
        sort: true,
        display: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.rowIndex + 1;
        },
      },
    },
    {
      name: 'languageId',
      label: 'Language',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const lang = languages.find((lang) => lang.id === value);
          return lang ? lang[getDefName()] : '';
        },
      },
    },
    {
      name: 'image',
      label: 'Photo',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value && value.url) {
            return <img src={value.url} width={30} alt={value.name || ''} />;
          } else {
            return '';
          }
        },
      },
    },
    {
      name: 'name_ko',
      label: 'Name(Kor)',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'name_en',
      label: 'Name',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'hospitalId',
      label: 'Hospital',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const _hos = hospitals.find((hos) => hos.id === value);
          return _hos ? _hos['name_ko'] : '';
        },
      },
    },
    {
      name: 'hidden',
      label: 'Show/Hide',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? <span style={{ color: 'grey' }}>Hide</span> : <span style={{ color: 'green', fontWeight: 500 }}>Show</span>;
        },
      },
    },
    {
      name: 'createdAt',
      label: 'Registration Date',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return moment(Number(value)).format('YYYY-MM-DD HH:mm');
        },
      },
    },
    {
      name: 'viewCnt',
      label: 'View Count',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value || 0;
        },
      },
    },
    {
      name: 'detail',
      label: 'Detail',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button
              color="primary"
              onClick={() => rowClick(data[tableMeta.rowIndex])}
              style={{ borderRadius: '100%', aspectRatio: '1/1', width: 30, height: 30 }}
            >
              <SearchIcon />
            </Button>
          );
        },
      },
    },
  ];

  const rowDelete = (row) => {
    let ids = [];
    row.data.map((r) => {
      ids.push(data[r.dataIndex].id);
      return r;
    });
    let delParam = {
      ids: ids.toString(),
    };
    swal({
      title: 'Are you sure you want to delete?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.post(`${API_URL}/doctor/deleteIds`, delParam, { headers: { Pragma: 'no-cache' } }).then((response) => {
          swal('It is deleted.', {
            icon: 'success',
          });
          getData();
        });
      } else {
        getData();
      }
    });
  };

  const options = {
    print: false,
    filter: false,
    filterType: 'checkbox',
    selectableRows: 'multiple',
    viewColumns: false,
    download: false,
    // onRowClick: rowClick,
    onRowsDelete: rowDelete,

    onTableChange: (action, tableState) => {
      tableStateRef.current = tableState.displayData;
    },
    customToolbar: () => (
      <Button
        variant="contained"
        onClick={handleFilteredExcelDownload}
        startIcon={<GetAppRoundedIcon />}
        style={{ color: '#ffffff', backgroundColor: '#1d6f42' }}
      >
        Excel download
      </Button>
    ),
  };

  useEffect(() => {
    getData();
    getHospitalList(true).then((result) => {
      setHospitals(result);
    });
    getLanguageList().then((result) => {
      setLanguages(result);
    });
  }, []);

  return (
    <OftadehLayout>
      <CustomListHeader history={history} url={'/pages/recDoctor/edit?type=new'} data={data} type="Doctor" />

      {/*<OftadehBreadcrumbs path={history} />*/}
      <MUIDataTable title={''} data={data} columns={cols} options={options} />
      {loading && (
        <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 999 }}>
          <CircularProgress color={'secondary'} />
        </div>
      )}
    </OftadehLayout>
  );
};

export default RecDoctorListPage;
